module.exports = __webpack_public_path__ + "static/media/icon-help-error.ce6ba2c5.svg";